export interface InternationalTopUpOfferItem {
    id: string;
    categoryId: string;
    title: string;
    price: number;
    currency: string;
    shortDescription: string;
    longDescription: string;
}
